// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.RentalManagerUserPropertyEditWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  ListingAlias,
  UserPropertyEditPetsWebApiRequestDto,
  UserPropertyIsConnectedExperienceResponseWebDto,
} from '../..';

interface IsConnectedExperienceParams {
  listingAlias: ListingAlias;
}
interface IsListingEditableParams {
  listingAlias: ListingAlias;
  multiplexBuildingSessionId?: string;
}

export const RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Path =
  '/api/web/v1/users/properties/isConnectedExperience';

/**
 * Get isConnectedExperience for a listing
 */
export const RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience = (
  getParams: IsConnectedExperienceParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsConnectedExperienceParams, never, UserPropertyIsConnectedExperienceResponseWebDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_isConnectedExperience_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_isListingEditable_Path =
  '/api/web/v1/users/properties/isListingEditable';

/**
 * Check whether the listing (or multiplex building units) can be edited; no side effects
 */
export const RentalManagerUserPropertyEditWebApiHandler_isListingEditable = (
  getParams: IsListingEditableParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsListingEditableParams, never, boolean>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPropertyEditWebApiHandler_isListingEditable_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPropertyEditWebApiHandler_pets_Path = '/api/web/v1/users/properties/pets';

/**
 * Update pet policy of a property
 */
export const RentalManagerUserPropertyEditWebApiHandler_pets = (
  postData: UserPropertyEditPetsWebApiRequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, UserPropertyEditPetsWebApiRequestDto, void>(
    {
      endpoint: RentalManagerUserPropertyEditWebApiHandler_pets_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
